// extracted by mini-css-extract-plugin
export default {"container":"InputAutoComplete_container__XrrLR","optionsContainer":"InputAutoComplete_optionsContainer__iKC4n","gLogo":"InputAutoComplete_gLogo__fbaoz"};